export const qk = {
    connect:    (entity, qs, search) => ['connect', entity, qs || '', search || ''],
    hconnect:   (entity, qs)       => qs ? ['hconnect', entity, qs] : ['hconnect', entity],
    // lang (labelLanguage 'ui') sits at index 4, after a qs slot, so Select's queryFn finds it
    select:     (entity, country, qs, lang) => lang ? ['select', entity, country, qs ?? null, lang] : qs ? ['select', entity, country, qs] : ['select', entity, country],
    currency:   (entity, country)  => ['currency', entity, country],
    dualMain:   (entity, qs)       => qs ? ['dualMain', entity, qs] : ['dualMain', entity],
    dualSub:    (entity, parentId) => ['dualSub', entity, parentId],
    listWidget: (entity, filter)   => filter ? ['listWidget', entity, filter] : ['listWidget', entity],
    subList:    (entity, id, fv)   => ['subList', entity, id, fv],
}
